// import components
import { Button, ListSubheader, styled } from '@mui/material';

// import utils
import { rgbaPrimary } from 'constants/colors';

export const StyledTaskListToggleButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isOpen'
})<{ isOpen: boolean }>(({ theme, isOpen }) => ({
  position: 'fixed',
  right: theme.spacing(4),
  minWidth: 'inherit',
  width: theme.spacing(10),
  height: theme.spacing(10),
  border: 0,
  borderRadius: '50%',
  backgroundColor: isOpen ? 'inherit' : rgbaPrimary(0.1),

  '> *': {
    minWidth: 0,

    svg: {
      minWidth: 'inherit'
    }
  }
}));

export const StyledTaskListHeader = styled(ListSubheader)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  backgroundColor: 'transparent',
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(6),
  marginBottom: theme.spacing(2)
}));
